// auth
export const LOGIN = "login";
export const LOGOUT = "logout";

// region
export const SET_REGION = "setRegion";

// product
export const CLEAR_PRODUCT_ERRORS = "clearProductErrors";
export const AWS_SEARCH_MULTISELECT_PRODUCTS = "awsSearchMultiselectProducts";

// component
export const FETCH_ALL_COMPONENT = "fetchAllComponent";
export const DELETE_COMPONENT = "deleteComponent";
export const CLEAR_COMPONENT_ERRORS = "clearComponentErrors";
export const CLEAR_COMPONENT_SUCCESS = "clearComponentSuccess";
export const UPDATE_INSTANCE_NAME = "updateInstanceName";
export const UPDATE_INSTANCE_DESCRIPTION = "updateInstanceDescription";
export const SET_DESCRIPTION_CACHE = "setDescriptionCache";
export const CLEAR_HARDREFRESH_ERRORS = "clearHardRefreshErrors";
export const CLEAR_HARDREFRESH_SUCCESS = "clearHardRefreshSuccess";

// componentAttributes
export const FETCH_COMPONENT_DATA = "fetchComponentData";
export const FETCH_INSTANCE_INFO = "fetchInstanceInfo";
export const FETCH_SYNC_INSTANCE_INFO = "fetchSyncInstanceInfo";
export const UPDATE_COMPONENT_DATA = "updateComponentData";
export const CHANGE_OPERATION_MODE = "changeOperationMode";
export const CREATE_COMPONENT_DATA = "createComponentData";
export const COPY_COMPONENT_DATA = "copyComponentData";
export const DELETE_COMPONENT_DATA = "deleteComponentData";
export const ADD_COMPONENT_ERRORS = "addComponentErrors";
export const SEARCH_INSTANCE = "searchInstance";
export const INSTANCE_SET_PAGE = "instanceSetPage";
export const FETCH_COMPONENT_ATTRIBUTES = "fetchComponentAttributes";
export const CLEAR_COMPONENT_ATTRIBUTES = "clearComponentAttributes";
export const GLOBAL_SEARCH_INSTANCE = "globalSearchInstance";
export const CLEAR_GLOBAL_SEARCH_RESULT = "clearGlobalSearchResult";
export const SYNC_COMPONENT_INSTANCE = "syncComponentInstance";
export const SYNC_BLOG_INSTANCE = "suncBlogInstance";

// abiImageSlider
export const FETCH_SLIDE_INSTANCE = "fetchSlideInstance";
export const FETCH_SLIDE_ATTRIBUTES = "fetchSlideAttributes";
export const CREATE_SLIDER_INSTANCE = "createSliderInstance";
export const UPDATE_SLIDER_INSTANCE = "updateSliderInstance";
export const COPY_SLIDER_INSTANCE = "copySliderInstance";

// category
export const GET_CATEGORY_INFO = "getCategoryInfo";
export const ADD_CATEGORY_ERRORS = "addCategoryErrors";
export const ADD_CATEGORY_ATTRIBUTES = "addCategoryAttributes";
export const FETCH_CATEGORY_ATTRIBUTES = "fetchCategoryAttributes";
export const CREATE_CATEGORY_INSTANCE = "createCategoryInstance";
export const UPDATE_CATEGORY_INSTANCE = "updateCategoryInstance";
export const FETCH_CATEGORY_INSTANCE = "fetchCategoryInstance";
export const CHANGE_CATEGORY_OPERATION = "changeCategoryOperation";
export const SET_CATEGORY_LOADING_STATUS = "setCategoryLoadingStatus";
export const CLEAR_CATEGORY_ERRORS = "clearCategoryErrors";
export const CLEAR_CATEGORY_SUCCESS = "clearCategorySuccess";
export const CATEGORY_INSTANCE_SEARCH = "categoryInstanceSearch";
export const CATEGORY_OPTIONS_SEARCH = "categoryOptionsSearch";
export const SET_CATEGORY_PAGE = "setCategoryPage";
export const FETCH_EXIST_CATEGORY = "fetchExistCategory";
export const FETCH_INTRO_INSTANCE_INFO = "fetchIntroInstanceInfo";

// blog
export const CLEAR_BLOG_ERRORS = "clearBlogErrors";
export const CLEAR_BLOG_SUCCESS = "clearBlogSuccess";
export const SET_BLOG_ERRORS = "setBlogErrors";
export const DELETE_BLOG_POST = "deleteBlogPost";
export const CHANGE_BLOG_OPERATION = "changeBlogOperation";
export const FETCH_BLOG_COMPONENT_ATTR = "fetchBlogComponentAttr";
export const FETCH_BLOG_COMPONENT_INSTANCE = "fetchBlogComponentInstance";
export const SET_SELECTED_BLOG_INSTANCE = "setSelectedBlogInstance";
export const CLEAR_BLOG_COMPONENT_ATTR = "clearBlogComponentAttr";
export const CLEAR_BLOG_COMPONENT_LOADING = "clearBlogComponentLoading";
export const CLEAR_BLOG_SELECTED_INSTANCE = "clearBlogSelectedInstance";
export const CREATE_BLOG_COMPONENT_INSTANCE = "createBlogComponentInstance";
export const DUPLICATE_BLOG_COMPONENT_INSTANCE =
  "duplicateBlogComponentInstance";
export const UPDATE_BLOG_COMPONENT_INSTANCE = "updateBlogComponentInstance";
export const DELETE_SELECTED_INSTANCE = "deleteSelectedInstance";
export const DELETE_COMPONENT_ATTRIBUTE = "deleteComponentAttribute";

// draft
export const SET_DRAFT_MODE = "setDraftMode";
export const FETCH_DRAFT_INFO = "fetchDraftInfo";
export const UPDATE_DRAFT_INSTANCE = "updateDraftInstance";
export const CREATE_DRAFT_INSTANCE = "createDraftInstance";

// notice
export const FETCH_DELAY_MESSAGE = "fetchDelayMessage";
export const UPDATE_DELAY_MESSAGE = "updateDelayMessage";
